import { createFileRoute } from '@tanstack/react-router';

import { getResultsQueries, ResultPage } from '@results';

export const Route = createFileRoute('/_app/_admin/results_/$id')({
  loader: async ({ context, params }) => {
    const queries = getResultsQueries();
    await context.queryClient.prefetchQuery(queries.detail(Number(params.id)));
  },
  component: ResultPage,
});
